import api from '../../services/api';

const urlBase = '/assinaturas';

export default {
  listarPlanos: () => api.get(`${urlBase}/planos`),

  buscarAssinaturaAtual: () => api.get(`${urlBase}/atual`),

  criarSessaoCheckout: (planoId) =>
    api.post(`${urlBase}/checkout`, { plano_id: planoId }),

  confirmarAssinatura: (sessionId) =>
    api.post(`${urlBase}/confirmar`, { session_id: sessionId }),

  cancelarAssinatura: () =>
    api.post(`${urlBase}/cancelar`),
};
